export default __webpack_public_path__ + "5bbd7f2fae9d4e19d83c9d7f165180ba.svg";